module.exports = __webpack_public_path__ + "static/media/StepperIcon_3.8af8d9b0.png";